import { loginRequest } from "../config/authConfig";
import { apiEndpoints } from "../config/apiConfig";
async function getAccessToken(instance) {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) {
        throw new Error("No accounts found. Please sign in.");
    }
    const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
    });
    return response.accessToken;
}
async function apiRequest(instance, url, options = {}) {
    const token = await getAccessToken(instance);
    const response = await fetch(url, {
        ...options,
        headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error ${response.status}: ${errorText}`);
    }
    const text = await response.text();
    if (!text) {
        return undefined;
    }
    return JSON.parse(text);
}
// Warehouses
export function getWarehouses(instance) {
    return apiRequest(instance, apiEndpoints.warehouses);
}
// Procurement Catalog
export function searchCatalog(instance, search, page = 1, pageSize = 25) {
    const conditions = `identifier contains "${search}" and inactiveflag=false`;
    const params = new URLSearchParams({
        conditions,
        page: String(page),
        pagesize: String(pageSize),
    });
    return apiRequest(instance, `${apiEndpoints.procurementCatalog}?${params.toString()}`);
}
// Stock Buckets
export function getStockBuckets(instance) {
    return apiRequest(instance, apiEndpoints.stockBucket);
}
export function createStockBucket(instance, payload) {
    return apiRequest(instance, apiEndpoints.stockBucket, {
        method: "POST",
        body: JSON.stringify(payload),
    });
}
export function updateStockBucket(instance, id, payload) {
    return apiRequest(instance, `${apiEndpoints.stockBucket}/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}
export function deleteStockBucket(instance, id) {
    return apiRequest(instance, `${apiEndpoints.stockBucket}/${id}`, {
        method: "DELETE",
    });
}
// Stock Bucket Items
export function getStockBucketItems(instance) {
    return apiRequest(instance, apiEndpoints.stockBucketItem);
}
export function createStockBucketItem(instance, payload) {
    return apiRequest(instance, apiEndpoints.stockBucketItem, {
        method: "POST",
        body: JSON.stringify(payload),
    });
}
export function deleteStockBucketItem(instance, id) {
    return apiRequest(instance, `${apiEndpoints.stockBucketItem}/${id}`, {
        method: "DELETE",
    });
}
export function updateStockBucketItem(instance, id, payload) {
    return apiRequest(instance, `${apiEndpoints.stockBucketItem}/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}
